<template>
  <div class="Type" :style="{ backgroundImage: `url(${images.bgImage})` }">
    <!-- 户型选择按钮 -->
    <div class="type-buttons">
      <div
        v-for="(type, index) in houseTypes"
        :key="index"
        class="type-btn"
        @click="selectType(index)"
      >
        <img
          :src="activeTypeIndex === index ? type.btnSelected : type.btnNormal"
          alt=""
        />
      </div>
    </div>

    <!-- 主要内容区 -->
    <div class="swiper-container TypeSwiper">
      <div class="swiper-wrapper">
        <!-- 落位图页面 -->
        <div class="swiper-slide luowei-page">
          <img :src="images.luoweiBg" class="luowei-bg" alt="" />
          
          <!-- 落位图左右滑动区域 -->
          <div class="swiper-container LuoweiSwiper">
            <div class="swiper-wrapper">
              <div
                v-for="(type, index) in houseTypes"
                :key="index"
                class="swiper-slide luowei-item"
              >
                <img
                  :src="type.luoweiBlock"
                  class="luowei-block"
                  :class="{ active: activeTypeIndex === index }"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>

        <!-- 平面图页面 -->
        <div class="swiper-slide pingmian-page">
          <!-- 平面图左右滑动区域（户型切换） -->
          <div class="swiper-container PingmianSwiper">
            <div class="swiper-wrapper">
              <div
                v-for="(type, index) in houseTypes"
                :key="index"
                class="swiper-slide pingmian-item"
              >
                <div class="pingmian-container">
                  <!-- 楼层左右滑动区域 -->
                  <div :class="'swiper-container FloorSwiper-' + index" style="transform: translateY(-15vw);">
                    <div class="swiper-wrapper">
                      <div
                        v-for="(floor, floorIndex) in type.floors"
                        :key="floorIndex"
                        class="swiper-slide floor-item"
                      >
                        <img
                          :src="floor.image"
                          class="pingmian-img"
                          style="width:90%;margin: 0 auto;"
                          alt=""
                          @click="previewImage(floor.image)"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- 滑动指示点（移到容器外） -->
                  <div :class="'swiper-pagination floor-pagination-' + index"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 上下滑动提示箭头 -->
    <!-- 落位图页面：向上滑提示 -->
    <div class="slide-prompt slide-up" v-if="!isInPingmian">
      <img :src="images.upArrow" alt="" class="floatY" />
    </div>
    
    <!-- 平面图页面：向下滑提示 -->
    <div class="slide-prompt slide-down" v-if="isInPingmian">
      <img :src="images.downArrow" alt="" class="floatY-reverse" />
    </div>

    <!-- 图片预览模态框 -->
    <div v-if="previewVisible" class="image-preview-modal" @click="closePreview">
      <div class="preview-content" @click.stop>
        <img 
          :src="previewImageUrl" 
          :style="{ transform: `scale(${imageScale}) translate(${translateX}px, ${translateY}px)` }"
          @wheel="handleWheel"
          @mousedown="startDrag"
          @mousemove="onDrag"
          @mouseup="endDrag"
          @mouseleave="endDrag"
          class="preview-img"
          alt=""
        />
        <div class="preview-controls">
          <button @click="zoomIn" class="control-btn">
            <img :src="images.amplifyOn" alt="放大" style="width: 100%; height: 100%;" />
          </button>
          <button @click="resetZoom" class="control-btn">1:1</button>
          <button @click="zoomOut" class="control-btn">
            <img :src="images.amplifyOff" alt="缩小" style="width: 100%; height: 100%;" />
          </button>
        </div>
        <button @click="closePreview" class="close-btn">✕</button>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/dist/js/swiper";

const IMAGE_BASE = "./static/images/Type";

export default {
  data() {
    return {
      // Swiper 实例
      mainSwiper: null,
      luoweiSwiper: null,
      pingmianSwiper: null,
      floorSwipers: [], // 每个户型的楼层Swiper实例数组

      // 当前选中的户型索引
      activeTypeIndex: 0,

      // 每个户型的当前楼层索引
      currentFloorIndexes: [0, 0, 0, 0], // 对应4个户型

      // 是否在平面图页面
      isInPingmian: false,

      // 公共图片
      images: {
        bgImage: `${IMAGE_BASE}/bg.jpg`,
        luoweiBg: `${IMAGE_BASE}/luowei/落位底图.png`,
        upArrow: `${IMAGE_BASE}/上滑.png`,
        downArrow: `${IMAGE_BASE}/下滑.png`,
        amplifyOn: require('../assets/imgs/amplify-on.png'),
        amplifyOff: require('../assets/imgs/amplify-off.png')
      },

      // 图片预览相关
      previewVisible: false,
      previewImageUrl: '',
      imageScale: 1,
      translateX: 0,
      translateY: 0,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,

      // 户型配置
      houseTypes: [
        {
          name: "上叠200",
          btnNormal: `${IMAGE_BASE}/btn/上叠200n.png`,
          btnSelected: `${IMAGE_BASE}/btn/上叠200s.png`,
          luoweiBlock: `${IMAGE_BASE}/luowei/上叠色块.png`,
          floors: [
            {
              name: "负一层",
              image: `${IMAGE_BASE}/pingmian/shangdie/-1.png`
            },
            {
              name: "三层",
              image: `${IMAGE_BASE}/pingmian/shangdie/3.png`
            },
            {
              name: "四层",
              image: `${IMAGE_BASE}/pingmian/shangdie/4.png`
            },
            {
              name: "露台",
              image: `${IMAGE_BASE}/pingmian/shangdie/露台.png`
            }
          ]
        },
        {
          name: "下叠200",
          btnNormal: `${IMAGE_BASE}/btn/下叠200n.png`,
          btnSelected: `${IMAGE_BASE}/btn/下叠200s.png`,
          luoweiBlock: `${IMAGE_BASE}/luowei/下叠色块.png`,
          floors: [
            {
              name: "负一层",
              image: `${IMAGE_BASE}/pingmian/xiadie/-1.png`
            },
            {
              name: "一层",
              image: `${IMAGE_BASE}/pingmian/xiadie/1.png`
            },
            {
              name: "二层",
              image: `${IMAGE_BASE}/pingmian/xiadie/2.png`
            }
          ]
        },
        {
          name: "合院230",
          btnNormal: `${IMAGE_BASE}/btn/合院230n.png`,
          btnSelected: `${IMAGE_BASE}/btn/合院230s.png`,
          luoweiBlock: `${IMAGE_BASE}/luowei/合院230色块.png`,
          floors: [
            {
              name: "负一层",
              image: `${IMAGE_BASE}/pingmian/heyuan230/-1.png`
            },
            {
              name: "一层",
              image: `${IMAGE_BASE}/pingmian/heyuan230/1.png`
            },
            {
              name: "二层",
              image: `${IMAGE_BASE}/pingmian/heyuan230/2.png`
            },
            {
              name: "三层",
              image: `${IMAGE_BASE}/pingmian/heyuan230/3.png`
            }
          ]
        },
        {
          name: "合院260",
          btnNormal: `${IMAGE_BASE}/btn/合院260n.png`,
          btnSelected: `${IMAGE_BASE}/btn/合院260s.png`,
          luoweiBlock: `${IMAGE_BASE}/luowei/合院260色块.png`,
          floors: [
            {
              name: "负一层",
              image: `${IMAGE_BASE}/pingmian/heyuan260/-1.png`
            },
            {
              name: "一层",
              image: `${IMAGE_BASE}/pingmian/heyuan260/1.png`
            },
            {
              name: "二层",
              image: `${IMAGE_BASE}/pingmian/heyuan260/2.png`
            },
            {
              name: "三层",
              image: `${IMAGE_BASE}/pingmian/heyuan260/3.png`
            }
          ]
        }
      ]
    };
  },

  computed: {
    // 当前户型
    currentType() {
      return this.houseTypes[this.activeTypeIndex];
    },
    // 当前户型的当前楼层索引
    currentFloorIndex() {
      return this.currentFloorIndexes[this.activeTypeIndex] || 0;
    }
  },

  mounted() {
    this.initSwiper();
  },

  beforeDestroy() {
    if (this.mainSwiper) {
      this.mainSwiper.destroy();
    }
    if (this.luoweiSwiper) {
      this.luoweiSwiper.destroy();
    }
    if (this.pingmianSwiper) {
      this.pingmianSwiper.destroy();
    }
    // 销毁所有楼层Swiper实例
    this.floorSwipers.forEach(swiper => {
      if (swiper) {
        swiper.destroy();
      }
    });
  },

  methods: {
    // 初始化 Swiper
    initSwiper() {
      this.$nextTick(() => {
        // 初始化落位图左右滑动
        this.luoweiSwiper = new Swiper(".LuoweiSwiper", {
          direction: "horizontal",
          effect: "coverflow",
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: "auto",
          initialSlide: 0,
          coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2,
            slideShadows: false
          },
          on: {
            slideChange: () => {
              // 联动更新户型索引和平面图
              const newIndex = this.luoweiSwiper.activeIndex;
              this.activeTypeIndex = newIndex;
              
              // 重置当前户型的楼层到第一层
              this.$set(this.currentFloorIndexes, newIndex, 0);
              if (this.floorSwipers[newIndex]) {
                this.floorSwipers[newIndex].slideTo(0);
              }
              
              // 联动平面图Swiper
              if (this.pingmianSwiper && this.pingmianSwiper.activeIndex !== newIndex) {
                this.pingmianSwiper.slideTo(newIndex);
              }
            },
            transitionEnd: () => {
              // 滑动停止后的闪烁动画效果（仅落位图）
              this.addSlideAnimation();
            }
          }
        });

        // 初始化平面图左右滑动
        this.pingmianSwiper = new Swiper(".PingmianSwiper", {
          direction: "horizontal",
          effect: "coverflow",
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: "auto",
          initialSlide: 0,
          coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2,
            slideShadows: false
          },
          on: {
            slideChange: () => {
              // 联动更新户型索引和落位图
              const newIndex = this.pingmianSwiper.activeIndex;
              this.activeTypeIndex = newIndex;
              
              // 重置当前户型的楼层到第一层
              this.$set(this.currentFloorIndexes, newIndex, 0);
              if (this.floorSwipers[newIndex]) {
                this.floorSwipers[newIndex].slideTo(0);
              }
              
              // 联动落位图Swiper
              if (this.luoweiSwiper && this.luoweiSwiper.activeIndex !== newIndex) {
                this.luoweiSwiper.slideTo(newIndex);
              }
            }
          }
        });

        // 初始化主上下滑动
        this.mainSwiper = new Swiper(".TypeSwiper", {
          direction: "vertical",
          on: {
            slideChange: () => {
              this.isInPingmian = this.mainSwiper.activeIndex === 1;
            }
          }
        });

        // 延迟初始化每个户型的楼层滑动，确保DOM完全渲染
        setTimeout(() => {
          this.houseTypes.forEach((type, index) => {
            const vm = this; // 保存Vue实例引用
            const floorSwiper = new Swiper(`.FloorSwiper-${index}`, {
              direction: "horizontal",
              grabCursor: true,
              initialSlide: 0,
              speed: 400,
              observer: true,
              observeParents: true,
              pagination: {
                el: `.floor-pagination-${index}`,
                clickable: true,
                bulletClass: 'floor-bullet',
                bulletActiveClass: 'floor-bullet-active',
                type: 'bullets',
                renderBullet: function (index, className) {
                  return '<span class="' + className + '"></span>';
                }
              },
              on: {
                slideChange: function() {
                  // 更新当前户型的楼层索引
                  vm.$set(vm.currentFloorIndexes, index, this.activeIndex);
                }
              }
            });
            this.floorSwipers.push(floorSwiper);
            console.log(`FloorSwiper-${index} initialized with pagination:`, floorSwiper.pagination);
          });
        }, 100);
      });
    },

    // 选择户型
    selectType(index) {
      this.activeTypeIndex = index;
      // 重置到第一层
      this.$set(this.currentFloorIndexes, index, 0);
      
      // 联动落位图Swiper
      if (this.luoweiSwiper && this.luoweiSwiper.activeIndex !== index) {
        this.luoweiSwiper.slideTo(index);
      }
      
      // 联动平面图Swiper
      if (this.pingmianSwiper && this.pingmianSwiper.activeIndex !== index) {
        this.pingmianSwiper.slideTo(index);
      }
      
      // 重置对应户型的楼层Swiper到第一层
      if (this.floorSwipers[index]) {
        this.floorSwipers[index].slideTo(0);
      }
    },

    // 滑动停止后的闪烁动画效果（仅用于落位图）
    addSlideAnimation() {
      const activeSlide = document.querySelector('.luowei-item.swiper-slide-active .luowei-block');
      
      if (activeSlide) {
        activeSlide.classList.remove('slide-stop-animation');
        // 强制重绘
        void activeSlide.offsetWidth;
        activeSlide.classList.add('slide-stop-animation');
        
        // 动画结束后移除class（与动画时长匹配）
        setTimeout(() => {
          activeSlide.classList.remove('slide-stop-animation');
        }, 800);
      }
    },

    // 图片预览相关方法
    previewImage(imageUrl) {
      this.previewImageUrl = imageUrl;
      this.previewVisible = true;
      this.imageScale = 1;
      this.translateX = 0;
      this.translateY = 0;
      // 禁止页面滚动
      document.body.style.overflow = 'hidden';
    },

    closePreview() {
      this.previewVisible = false;
      this.imageScale = 1;
      this.translateX = 0;
      this.translateY = 0;
      this.isDragging = false;
      // 恢复页面滚动
      document.body.style.overflow = '';
    },

    zoomIn() {
      this.imageScale = Math.min(this.imageScale + 0.25, 5);
    },

    zoomOut() {
      this.imageScale = Math.max(this.imageScale - 0.25, 0.5);
    },

    resetZoom() {
      this.imageScale = 1;
      this.translateX = 0;
      this.translateY = 0;
    },

    handleWheel(e) {
      e.preventDefault();
      if (e.deltaY < 0) {
        this.zoomIn();
      } else {
        this.zoomOut();
      }
    },

    startDrag(e) {
      if (this.imageScale > 1) {
        this.isDragging = true;
        this.dragStartX = e.clientX - this.translateX;
        this.dragStartY = e.clientY - this.translateY;
      }
    },

    onDrag(e) {
      if (this.isDragging) {
        this.translateX = e.clientX - this.dragStartX;
        this.translateY = e.clientY - this.dragStartY;
      }
    },

    endDrag() {
      this.isDragging = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.Type {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;

  // 户型选择按钮
  .type-buttons {
    position: absolute;
    width: 90%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    z-index: 1000;
    margin-top: 60vw;
    justify-content: space-between;

    .type-btn {
      cursor: pointer;
      transition: all 0.3s ease;
      width: 18vw;

      img {
        width: 100%;
        height: auto;
      }

      &:hover {
        transform: scale(1.05);
      }

      &:active {
        transform: scale(0.95);
      }
    }
  }

  // Swiper 容器
  .TypeSwiper {
    width: 100%;
    height: 100%;
  }

  // 落位图页面
  .luowei-page {
    width: 100vw;
    height: 100vh;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .luowei-bg {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    // 落位图左右滑动容器
    .LuoweiSwiper {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: visible;

      .swiper-wrapper {
        height: 100%;
      }

      .luowei-item {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        
        .luowei-block {
          width: 100%;
          height: 100%;
          object-fit: contain;
          transition: all 0.3s ease;
          
          // 滑动停止后的闪烁动画
          &.slide-stop-animation {
            animation: slideStopPulse 0.8s ease;
          }
        }

        // 非激活状态的落位图
        &:not(.swiper-slide-active) {
          .luowei-block {
            opacity: 0.3;
            transform: scale(0.85);
          }
        }

        // 激活状态的落位图
        &.swiper-slide-active {
          .luowei-block {
            opacity: 1;
            transform: scale(1);
          }
        }
      }
    }
  }

  // 平面图页面
  .pingmian-page {
    width: 100vw;
    height: 100vh;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;

    // 平面图左右滑动容器
    .PingmianSwiper {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: visible;

      .swiper-wrapper {
        height: 100%;
      }

      .pingmian-item {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        // 非激活状态的平面图
        &:not(.swiper-slide-active) {
          .pingmian-container {
            opacity: 0.3;
            transform: scale(0.85);
          }
        }

        // 激活状态的平面图
        &.swiper-slide-active {
          .pingmian-container {
            opacity: 1;
            transform: scale(1);
          }
        }
      }
    }

    .pingmian-container {
      width: 100%;
      height: 100%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;

      // 楼层滑动容器
      [class^="FloorSwiper-"] {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;

        .swiper-wrapper {
          height: 100%;
        }

        .floor-item {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
    
        }

        .pingmian-img {
          max-width: 90%;
          max-height: 80%;
          object-fit: contain;
          cursor: pointer;
          transition: transform 0.3s ease, filter 0.3s ease;

          &:hover {
            transform: scale(1.02);
            filter: brightness(1.1);
          }
        }
      }

      // 楼层指示点容器（移到外层）
      [class^="floor-pagination-"] {
        position: absolute;
        bottom:12vh;
        left: 50%;
        transform: translateX(-50%);
        display: flex !important;
        align-items: center;
        gap: 6px;
        z-index: 1000;
        padding: 8px 16px;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 20px;
        backdrop-filter: blur(15px);
        pointer-events: auto;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.6), 0 0 30px rgba(0, 0, 0, 0.3);
        border: 2px solid rgba(255, 255, 255, 0.15);
      }
    }
  }

  // 楼层指示点样式（使用 ::v-deep 穿透）
  ::v-deep .floor-bullet {
    width: 5px !important;
    height: 5px !important;
    background: rgba(255, 255, 255, 0.6) !important;
    border-radius: 50% !important;
    cursor: pointer !important;
    transition: all 0.3s ease !important;
    border: 2px solid rgba(255, 255, 255, 0.9) !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.6), 0 0 15px rgba(255, 255, 255, 0.3) !important;
    opacity: 1 !important;
    display: inline-block !important;
    margin: 0 5px !important;

    &:hover {
      background: rgba(255, 255, 255, 0.9) !important;
      transform: scale(1.3) !important;
      border-color: rgba(255, 255, 255, 1) !important;
    }
  }

  ::v-deep .floor-bullet-active {
    background: #fff !important;
    border-color: #fff !important;
    box-shadow: 0 0 12px rgba(255, 255, 255, 1), 0 2px 8px rgba(0, 0, 0, 0.7), 0 0 18px rgba(255, 255, 255, 0.5) !important;
    transform: scale(1.4) !important;
    width: 7px !important;
    height: 7px !important;
  }

  // 滑动提示
  .slide-prompt {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3));
    opacity: 0.9;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 1;
    }

    img {
      width: 30vw;
      // max-width: 80px;
      // min-width: 50px;
      height: auto;
      display: block;
    }

    // 向上滑提示（落位图页面底部）
    &.slide-up {
      top: 8vh;
    }

    // 向下滑提示（平面图页面顶部）
    &.slide-down {
      top: 8vh;
    }
  }

  // 淡入淡出动画
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  // 缩放动画
  .zoom-enter-active,
  .zoom-leave-active {
    transition: all 0.5s ease;
  }

  .zoom-enter,
  .zoom-leave-to {
    opacity: 0;
    transform: scale(0.8);
  }

  // 上下浮动动画（向上）
  .floatY {
    animation: wbps_floatY 2s ease-in-out infinite;
  }

  @keyframes wbps_floatY {
    0%,
    100% {
      transform: translateY(0px);
    }
    25% {
      transform: translateY(-10px);
    }
    50% {
      transform: translateY(0px);
    }
    75% {
      transform: translateY(10px);
    }
  }

  // 上下浮动动画（向下，反向）
  .floatY-reverse {
    animation: wbps_floatY_reverse 2s ease-in-out infinite;
  }

  @keyframes wbps_floatY_reverse {
    0%,
    100% {
      transform: translateY(0px);
    }
    25% {
      transform: translateY(10px);
    }
    50% {
      transform: translateY(0px);
    }
    75% {
      transform: translateY(-10px);
    }
  }

  // 滑动停止后的闪烁动画
  @keyframes slideStopPulse {
    0% {
      opacity: 1;
    }
    25% {
      opacity: 0.3;
    }
    50% {
      opacity: 1;
    }
    75% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }

  // 图片预览模态框样式
  .image-preview-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.95);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.3s ease;

    .preview-content {
      position: relative;
      width: 90vw;
      height: 90vh;
      display: flex;
      align-items: center;
      justify-content: center;

      .preview-img {
        max-width: 100%;
        max-height: 100%;
        cursor: move;
        user-select: none;
        transition: transform 0.2s ease;
        will-change: transform;
      }

      .preview-controls {
        position: absolute;
        bottom: 5vh;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 20px;
        background: rgba(0, 0, 0, 0.8);
        padding: 15px 30px;
        border-radius: 50px;
        backdrop-filter: blur(10px);
        border: 2px solid rgba(255, 255, 255, 0.2);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);

        .control-btn {
          width: 50px;
          height: 50px;
          background: rgba(255, 255, 255, 0.15);
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          color: #fff;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;

          &:hover {
            background: rgba(255, 255, 255, 0.3);
            border-color: rgba(255, 255, 255, 0.6);
            transform: scale(1.1);
          }

          &:active {
            transform: scale(0.95);
          }
        }
      }

      .close-btn {
        position: absolute;
        top: 3vh;
        right: 3vw;
        width: 50px;
        height: 50px;
        background: rgba(255, 255, 255, 0.15);
        border: 2px solid rgba(255, 255, 255, 0.3);
        border-radius: 50%;
        color: #fff;
        font-size: 28px;
        font-weight: bold;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        line-height: 1;

        &:hover {
          background: rgba(255, 0, 0, 0.5);
          border-color: rgba(255, 0, 0, 0.8);
          transform: rotate(90deg) scale(1.1);
        }

        &:active {
          transform: rotate(90deg) scale(0.95);
        }
      }
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
}
</style>

<style lang="scss">
.swiper-pagination-bullets{
  position: absolute;
  top:50%;
  transform: translateY(-50%);
  margin-top: 42vw;
  // bottom: ;
}
// 全局样式（不使用 scoped）- 确保 Swiper pagination 样式生效
.floor-bullet {
  width: 5px !important;
  height: 5px !important;
  background: rgba(255, 255, 255, 0.6) !important;
  border-radius: 50% !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  border: 2px solid rgba(255, 255, 255, 0.9) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.6), 0 0 15px rgba(255, 255, 255, 0.3) !important;
  opacity: 1 !important;
  display: inline-block !important;
  margin: 0 5px !important;

  &:hover {
    background: rgba(255, 255, 255, 0.9) !important;
    transform: scale(1.3) !important;
    border-color: rgba(255, 255, 255, 1) !important;
  }
}

.floor-bullet-active {
  background: #fff !important;
  border-color: #fff !important;
  // box-shadow: 0 0 8px rgba(255, 255, 255, 1), 0 2px 8px rgba(0, 0, 0, 0.7), 0 0 18px rgba(255, 255, 255, 0.5) !important;
  transform: scale(1.4) !important;
  width: 4px !important;
  height: 4px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Type.vue